<a
  class="rounded-xs centered mobile-app-link"
  target="_blank"
  [href]="href"
  [attr.aria-label]="ariaLabel"
>
  <ng-content></ng-content>
</a>
